module.exports = __webpack_public_path__ + "img/logo-wo.4ea15c07.png";